import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProvider } from '@/common/providers';
import App from '@/App';
import '@/index.css';

import toast from 'react-hot-toast';

const originalToast = toast;
const customToast = (msg, options) => {
  return originalToast(msg, {
    id: typeof msg === 'string' ? msg : undefined,
    ...options,
  });
};

Object.assign(customToast, originalToast);

const originalError = toast.error;
customToast.error = (msg, options) => {
  return originalError(msg, {
    id: typeof msg === 'string' ? msg : undefined,
    ...options,
  });
};

const originalSuccess = toast.success;
customToast.success = (msg, options) => {
  return originalSuccess(msg, {
    id: typeof msg === 'string' ? msg : undefined,
    ...options,
  });
};

// Override the global toast object methods
Object.assign(toast, customToast);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>,
);
